let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5XfU")).then(() => parcelRequire('279SN'));